/** Query keys for FX rates (filter object embedded for stable partial matches). */
export const exchangeRateKeys = {
  all: () => ['exchange-rate'] as const,
  rate: (base: string, quote: string, date: string) =>
    [...exchangeRateKeys.all(), 'rate', { base, quote, date }] as const,
} as const;
